import React from 'react';
import './ButtonPrimary.scss';

export default function ButtonPrimary({ children, type, className, onClick, href, onMouseEnter, onMouseLeave, ...rest }) {
    const classes = `btn-primary ${className}` + (type ? ` ${type}` : '');

    return href ? (
        <a href={href} className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} {...rest}>
            {children}
        </a>
    ) : (
        <button className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} {...rest}>
            {children}
        </button>
    );
}
